module.exports = "/src/views/eternal-dev/businesses/gas-station/images/light/XEro/logo.svg";